import { render, staticRenderFns } from "./SectionSeverityFrom2022.vue?vue&type=template&id=f975ebe8"
import script from "./SectionSeverityFrom2022.vue?vue&type=script&lang=ts"
export * from "./SectionSeverityFrom2022.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports